module.exports = __webpack_public_path__ + "static/media/Single_decker_image.ab94cc35.jpg";